import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as env } from '../../../../environments/environment';
import { HttpService } from 'app/core';
import { CompetitorsPricesQueryList } from './models';
import {
    TableResponseQuery,
    FilterOutputModel,
    FiltersService,
    SettingsProvider, GeneralService,
} from 'app/core';
import { map } from 'rxjs/operators';
import { TableHelperService } from 'app/shared/tables/table-helper.service';

@Injectable()
export class CompetitorsPricesDataService {
    constructor(
        private http: HttpService,
        private filterService: FiltersService,
        private tableHelperService: TableHelperService,
        public settingsService: SettingsProvider,
        private generalService: GeneralService
    ) {}

    fetchData(
        top: number = 100,
        skip: number = 0,
        sortBy: string = 'StoreName',
        filter: string = '',
        selectFilters: FilterOutputModel[]
    ): Observable<TableResponseQuery> {
        const url = `${this.settingsService.configuration.url}${env.CompetitorsPricesDataService.apiUrlGetList}`;

        let params = new HttpParams();
        params = top ? params.set('$top', top.toString()) : params;
        params = skip ? params.set('$skip', skip.toString()) : params;
        params = sortBy ? params.set('$orderby', sortBy.toString()) : params;

        params = params.set('$count', 'true');

        // logic to set filter values
        if (filter || (selectFilters && !!selectFilters.length)) {
            const mainFilterString = this.filterService.setFilters(
                filter,
                selectFilters,
                this.tableHelperService.buildSearchUrl(
                    filter,
                    CompetitorsPricesQueryList.tableInfo().columns
                ),
                this.filterService.setSelectFiltersForList(
                    selectFilters,
                    CompetitorsPricesQueryList.tableInfo().columns
                )
            );
            params = params.set('$filter', mainFilterString);
        }

        return this.http.getWithParams(url, params).pipe(
            map((response) => {
                const items = this.generalService.toUpperCamelCaseObj(response.body.items);

                return new TableResponseQuery(
                    items,
                    response.body.count
                );
            }),
        );
    }

    public getCsv(): Observable<any> {
        const url = `${this.settingsService.configuration.url}${env.MainTableService.apiUrlExport}`;
        const params = new HttpParams()
            .set('configurationName', 'CompetitorsPrices')
            .set('contentType', 'text/csv');

        return this.http.getCSV(url, params);
    }

    public getXlsx(): Observable<any> {
        const url = `${this.settingsService.configuration.url}${env.MainTableService.apiUrlExport}`;
        const params = new HttpParams()
            .set('configurationName', `CompetitorsPrices`)
            .set(
                'contentType',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            );

        return this.http.getXlsx(url, params);
    }

    public delete(form: any): Observable<any> {
        const url = `${this.settingsService.configuration.url}${env.CompetitorsPricesDataService.apiUrlDeletePrice}`;
        return this.http.post(url, form);
    }
}
